import type { Point } from "./Point"
import type { Rectangle } from "./Rectangle"

export type SpatialRectangle<T> = Point<T> & Rectangle<T>
